import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FornecedorDetalharRoutingModule } from "./fornecedor-detalhar-routing.module";
import { FornecedorDetalharComponent } from "./fornecedor-detalhar.component";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { InputMaskModule } from "primeng/inputmask";
import { FormatPipeModule } from "src/app/admihair/format-pipe/format-pipe.module";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { MessagesModule } from "primeng/messages";




@NgModule({
    imports: [
        CommonModule,
        FornecedorDetalharRoutingModule,
        FormsModule,
        TableModule,
        ButtonModule,
        InputTextModule,
        InputMaskModule,
        FormatPipeModule,
        ProgressSpinnerModule,
        MessagesModule

    ],
    declarations: [FornecedorDetalharComponent]
})
export class FornecedorDetalharModule { }
